export default __webpack_public_path__ + "static/media/s2.cfbc3c86.jpeg";